import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { IonApp, IonIcon, IonLabel, IonRouterOutlet, IonTabBar, IonTabButton, IonTabs } from '@ionic/react';
import { IonReactHashRouter } from '@ionic/react-router';
import { speedometer, unlock, lock } from 'ionicons/icons';

/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';
import Dashboard from './pages/Dashboard/Dashboard';
import Connect from './pages/Connect/Connect';
import { GhostBle } from './ble/GhostBle';
import { useSelector } from 'react-redux';
import { RootState } from './store';

const App: React.FC = () => {
  const connected = useSelector((state: RootState) => state.ble.connected);
  const locked = useSelector((state: RootState) => state.ble.locked);
  const [displayLockDialog, setDisplayLockDialog] = useState(false);

  const unloadFunc = async (): Promise<void> => {
    await GhostBle.disconnect();
  };

  useEffect(() => {
    window.addEventListener('beforeunload', unloadFunc);

    return (): void => {
      window.removeEventListener('beforeunload', unloadFunc);
    };
  }, []);

  const ConnectRedirect = (): JSX.Element => {
    return <Redirect to="/connect" />;
  };

  const DashboardComponent = (): JSX.Element => (
    <Dashboard
      displayLockDialog={displayLockDialog}
      dismissLockDialogCallback={(): void => {
        setDisplayLockDialog(false);
      }}
    />
  );

  const requestLockClicked = async (): Promise<void> => {
    setDisplayLockDialog(true);
  };

  return (
    <IonApp>
      <IonReactHashRouter>
        <IonTabs>
          <IonRouterOutlet>
            <Route path="/connect" component={Connect} exact={true} />
            <Route path="/dashboard" component={!connected ? ConnectRedirect : DashboardComponent} exact={true} />
            <Route path="/" component={ConnectRedirect} exact={true} />
          </IonRouterOutlet>
          <IonTabBar slot="bottom">
            <IonTabButton tab="dashboard" href="/dashboard" hidden={!connected}>
              <IonIcon icon={speedometer} />
              <IonLabel>Temperature</IonLabel>
            </IonTabButton>
            {locked ? (
              <IonTabButton tab="lock" hidden={!connected} onClick={requestLockClicked}>
                <IonIcon icon={lock} />
                <IonLabel>{'Unlock'}</IonLabel>
              </IonTabButton>
            ) : (
              <IonTabButton tab="lock" hidden={!connected} onClick={requestLockClicked}>
                <IonIcon icon={unlock} />
                <IonLabel>{'Lock'}</IonLabel>
              </IonTabButton>
            )}
          </IonTabBar>
        </IonTabs>
      </IonReactHashRouter>
    </IonApp>
  );
};

export default App;
